<h2 mat-dialog-title>Manage Table Columns</h2>
<div mat-dialog-content>
  <div class="d-flex" fxlayout="row" fxlayoutgap="12px">
    <div class="list-column">
      <div class="column-title">Available Columns</div>
      <mat-list>
        @for (column of displayAvailableColumns; track column) {
          <mat-list-item class="header-box"
            [ngClass]="{ 'active': selectedColumn === column }" (click)="arrowClick(column)">
            {{ column.display }}
          </mat-list-item>
        }
      </mat-list>
    </div>
    <div class="column" fxLayout="column" fxflexalign="center">
      <div class="up-down-button-containers top-middle-column" fxlayoutalign="end"
        style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex; visibility: hidden;">
        @if (moveBack) {
          <mat-icon mattooltip="Move up">arrow_upward</mat-icon>
        }
      </div>
      <div class="d-flex" fxlayout="row" fxlayoutgap="12px">
        @if (moveForward) {
          <button mat-button-base mat-raised-button [disabled]="!selectedColumn"
            (click)="addSelectedColumns()"><mat-icon>chevron_right</mat-icon></button>
          }
          @if (moveBack) {
            <button mat-button-base mat-raised-button [disabled]="!selectedColumn"
              (click)="addSelectedColumns()"><mat-icon>chevron_left</mat-icon></button>
            }
          </div>
          <div class="up-down-button-containers top-middle-column" fxlayoutalign="end"
            style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex; visibility: hidden;">
            @if (moveBack) {
              <mat-icon mattooltip="Move down">arrow_downward</mat-icon>
            }
          </div>
        </div>
        <div class="list-column">
          <div class="column-title">Selected Columns</div>
          <mat-list>
            @for (column of displaySelectedColumns; track column) {
              @if (column.name !== 'select') {
                <mat-list-item class="header-box"
                  [ngClass]="{ 'active': selectedColumn === column }" (click)="availableArrowClick(column)">
                  {{ column.display }}
                </mat-list-item>
              }
            }
          </mat-list>
        </div>
      </div>
    </div>
    <div mat-dialog-actions class="action-btn">
      <button mat-button class="next-btn mat-primary" (click)="updateDisplayedColumns()">UPDATE</button>
      <button mat-button class="next-btn mat-default" (click)="cancelManageColumns()">CANCEL</button>
    </div>